import React from 'react';
var $mobile_max = '500px';
var $xs_min = '501px';
var $xs_max = '699px';
var $sm_min = '700px';
var $sm_max = '1099px';
var $md_min = '1100px';
var $md_max = '1439px';
var $lg_min = '1440px';
var $lg_max = '1799px';
var $xl_min = '1800px';
var queries = {
    'mobile': "(max-width: ".concat($mobile_max, ")"),
    'xs': "( min-width: ".concat($xs_min, ") and ( max-width: ").concat($xs_max, ")"),
    'sm': "( min-width: ".concat($sm_min, ") and ( max-width: ").concat($sm_max, ")"),
    'md': "( min-width: ".concat($md_min, ") and ( max-width: ").concat($md_max, ")"),
    'lg': "( min-width: ".concat($lg_min, ") and ( max-width: ").concat($lg_max, ")"),
    'xl': "( min-width: ".concat($xl_min, ")"),
    'desktop': "(min-width: ".concat($mobile_max, ")"),
    'moreSm': "(min-width: ".concat($sm_max, ")"),
};
export var SizeMediaScales = ['mobile', 'xs', 'sm', 'md', 'lg', 'xl'];
export function useMediaQuery(query, active) {
    if (active === void 0) { active = true; }
    var mediaMatch = window.matchMedia(queries[query]);
    var _a = React.useState(mediaMatch.matches), matches = _a[0], setMatches = _a[1];
    React.useEffect(function () {
        if (active) {
            var handler_1 = function (e) { setMatches(e.matches); };
            mediaMatch.addEventListener('change', handler_1);
            return function () { return mediaMatch.removeEventListener('change', handler_1); };
        }
    }, [active]);
    return matches;
}
export function useMediaQueryScales(active) {
    var mobile = useMediaQuery('mobile', active);
    var xs = useMediaQuery('xs', active);
    var sm = useMediaQuery('sm', active);
    var md = useMediaQuery('md', active);
    var lg = useMediaQuery('lg', active);
    var xl = useMediaQuery('xl', active);
    return {
        mobile: mobile,
        xs: xs,
        sm: sm,
        md: md,
        lg: lg,
        xl: xl,
    };
}
